import React, { useEffect, useState } from "react";
import styles from "./DataMonetizationTable.module.css";
import { env } from "../../constants/env";

const DataMonetizationTable = () => {
  const [strategies, setStrategies] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`${env.apiUrl}/api/data-engine`);
        const data = await res.json();

        // --- REQUIRED STRATEGIES ---
        const required = ["Phoenix", "Hydra",  "Penny Picker"];

        // --- DEFAULT FALLBACK OBJECT ---
        const empty = {
          equity: 0,
          MTD: 0,
          YTD: 0,
          maxDrawdown: 0,
          age: 0,
        };

        // Build the list ensuring all strategies exist
        const formatted = required.map((name) => {
          const found = data.find((d) => d.strategy === name);

          const row = found || { strategy: name, ...empty };

          return {
            strategy: name,
            equity: `$${Number(row.equity || 0).toLocaleString()}`,
            mtdGain: `${row.MTD || 0}%`,
            ytdGain: `${row.YTD || 0}%`,
            maxDrawdown:
              row.maxDrawdown !== undefined
                ? `${row.maxDrawdown.toFixed(2)}%`
                : "0%",
            age: row.age || 0,
          };
        });

        setStrategies(formatted);
      } catch (error) {
        console.error("Error fetching data engine:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Data Monetization Strategies</h3>

      <table className={styles.table}>
        <thead>
          <tr>
            <th>Strategy</th>
            <th>Equity</th>
            <th>YTD</th>
            <th>All</th>
            <th>Max Drawdown</th>
            <th>Age (Days)</th>
          </tr>
        </thead>

        <tbody>
          {strategies.map((item, idx) => (
            <tr key={idx}>
              <td>{item.strategy}</td>
              <td>{item.equity}</td>
              <td className={styles.positive}>{item.mtdGain}</td>
              <td className={styles.positive}>{item.ytdGain}</td>
              <td className={styles.negative}>{item.maxDrawdown}</td>
              <td>{item.age}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataMonetizationTable;